<template>
    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-2 mb-4">
        <div v-for="(option, key) in formattedOptions" :key="key" class="col">
            <Popper :content="errors[option.name]" arrow placement="top" class="w-100 m-0 border-0" :show="errors[option.name] ? true : false">
                <Field :id="option.name" v-slot="{ value }" :name="option.name" as="select" class="form-select size-input text-navy" :class="{'error': errors[option.name]}" :title="errors[option.name]" @change="settingSize(option.name, $event)">
                    <option value="">{{ option.label }}</option>
                    <template v-if="option.groups">
                        <optgroup v-if="option.groups.popular.length" label="Most Popular">
                            <option v-for="item in option.groups.popular" :key="'popular-' + item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                        </optgroup>
                        <optgroup v-if="option.groups.rest.length" :label="option.groups.allLabel">
                            <option v-for="item in option.groups.rest" :key="'all-' + item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                        </optgroup>
                    </template>
                    <template v-else>
                        <option v-for="item in option.data" :key="item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                    </template>
                </Field>
            </Popper>
        </div>
    </div>
</template>

<script>
    import { Form as VeeForm, Field } from 'vee-validate';
    import mostPopularSizes from '@shared/mixins/mostPopularSizes';

    export default {
        props: [
            'options',
            'postcode',
            'errors'
        ],
        mixins: [mostPopularSizes],
        components: {
            VeeForm,
            Field
        },
        data() {
            return {
                selectedWidth: '',
                selectedProfile: '',
                selectedRim: '',
            }
        },
        methods: {
            settingSize(name, event) {
                const before = {
                    width: this.selectedWidth,
                    profile: this.selectedProfile,
                    rim: this.selectedRim,
                };

                this.onSizeFieldChange(name, event);

                const after = this.selectedSizeParts;
                const fields = ['width', 'profile', 'rim', 'speed'];

                fields.forEach((field) => {
                    if (field === 'speed') {
                        if (name !== 'speed') {
                            return;
                        }

                        this.emitter.emit('updateManualSize', {
                            name: field,
                            value: event.target.value,
                        });

                        return;
                    }

                    if (name === field || before[field] !== after[field]) {
                        this.emitter.emit('updateManualSize', {
                            name: field,
                            value: after[field] === '' ? '' : parseInt(after[field], 10),
                        });
                    }
                });
            }
        },
        computed: {
            selectedSizeParts() {
                return {
                    width: this.selectedWidth,
                    profile: this.selectedProfile,
                    rim: this.selectedRim,
                };
            },
            formattedOptions: function() {
                return [
                    { label: 'Width', name: 'width', data: this.options.width },
                    { label: 'Profile', name: 'profile', data: this.options.profile },
                    { label: 'Rim', name: 'rim', data: this.options.rim },
                    { label: 'Speed', name: 'speed', data: this.options.speed },
                    { label: 'Load', name: 'load', data: this.options.load_index },
                ].map((option) => {
                    const groups = this.buildSizeGroups(option, this.selectedSizeParts);

                    if (!groups) {
                        return option;
                    }

                    return {
                        ...option,
                        data: [...groups.popular, ...groups.rest],
                        groups,
                    };
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .size-form {
        .size-input {
            background-color: #fff;
            height: 100%;
            width: 100%;
            margin-bottom: 10px;
            text-transform: capitalize;
            font-weight: 400;
            font-size: 1rem;
            border-radius: 3px;
            padding: 4.5px;
        }
        .btn {
            width: 100%;
            border-radius: 4px;
        }
    }
</style>
